/* eslint-disable react/function-component-definition */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faEdit } from "@fortawesome/fontawesome-free-solid"; // Added faEdit icon for the edit button
import { Entry } from "../../redux/entrySlice";
import styles from "./editCouponPopUp.module.scss";
import { TableContext } from "../../contexts/tableContext";
import "react-toastify/dist/ReactToastify.css";
import TextInput from "../../components/TextField/TextField";
import {
  REACT_APP_API_ROLES_DROPDOWN,
  REACT_APP_API_CAFES_DROPDOWN,
} from "../../redux/apiConstants";
import { Image } from "react-bootstrap";
import DateRangeFilter from "../../components/DateRangeFilter/DateRangeFilter";
import NumberInput from "../../components/NumberBox/NumberBox";
import { DateRangePicker } from "react-date-range";
import { addDays, set, subDays } from "date-fns";
import togglestyles from "../../components/ToggleButton/ToggleButton.module.scss";
import SelectBox from "../../components/SelectBox/SelectBox";
import axios from "axios";
import Loader from '../../components/Loader/Loader';

const EditCouponPopUp = React.memo(
  ({ couponId, handleClose, setIsUpdated, edit = true }) => {
    const [submitting, setSubmitting] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false); // New state to track edit mode
    const { formthemeStyle, bodyheader } = useContext(TableContext);
    const { errormsgStyle } = useContext(TableContext);
    const [coupon, setCoupon] = useState([]);
    const [error, setError] = useState(null);
    const [roles, setRoles] = useState([]);
    const dispatch = useDispatch();
    const { files } = useContext(TableContext);
    const [open, setOpen] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isOff, setIsOff] = useState();
    const [isFreeOff, setIsFreeOff] = useState();
    const [timeRestricted, setTimeRestricted] = useState(false);
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [selectedDays, setSelectedDays] = useState([]);

    const [loading, setLoading] = useState(true);
    const [cafes, setCafes] = useState([]);
    const [couponMode, setCouponMode] = useState("percentage");

    const RegularExp = /^[a-zA-Z0-9]*$/;

    const [state, setState] = useState([
      {
        startDate: new Date(),
        endDate: addDays(new Date(), 7),
        key: "selection",
      },
    ]);

    const handleOnChange = (ranges) => {
      const { selection } = ranges;
      handleDateRangeChange(selection);
      setState([selection]);
    };

    const handleButtonClick = () => {
      setIsOff(!isOff);
    };

    const handleDayToggle = (dayValue) => {
      setSelectedDays((prev) =>
        prev.includes(dayValue)
          ? prev.filter((d) => d !== dayValue)
          : [...prev, dayValue].sort()
      );
    };

    const handleDateRangeChange = (selection) => {
      console.log("Selected Date Range:", selection);
      
      const start = selection.startDate ? new Date(selection.startDate) : null;
      let end = selection.endDate ? new Date(selection.endDate) : null;
      
      // Always set end date to end of day (23:59:59.999)
      if (end) {
        end.setHours(23, 59, 59, 999);
      }
      
      setStartDate(start ? start.toISOString() : null);
      setEndDate(end ? end.toISOString() : null);
      setOpen(false);
    };

    const {
      control,
      register,
      handleSubmit,
      formState: { errors },
      getValues,
      setValue,
      reset,
      watch,
    } = useForm();

    useEffect(() => {
      setLoading(true);
      getCafes();
      const url2 = REACT_APP_API_ROLES_DROPDOWN;
      fetch(url2)
        .then((resp) => resp.json())
        .then((resp) => {
          setRoles(resp.data.role);
        });

      const actionData = {
        actionUrl: `coupons/${couponId}`,
        actionMethod: "get",
      };
      dispatch(Entry(actionData)).then((resp) => {
        if (resp.payload && resp.payload.data) {
          setCoupon(resp.payload.data);
          console.log("data: ", resp.payload.data);
          reset(resp.payload.data);
          setIsOff(resp?.payload?.data?.oneTime);
          setIsFreeOff(resp?.payload?.data?.multiple);
          setCouponMode(resp?.payload.data?.couponMode || "percentage");
          setStartDate(
            resp.payload.data.startDate ? resp.payload.data.startDate : null
          );
          setEndDate(
            resp.payload.data.endDate ? resp.payload.data.endDate : null
          );
          
          // Set time-based fields
          if (resp.payload.data.timeRestricted) {
            setTimeRestricted(true);
            setStartTime(resp.payload.data.startTime || "");
            setEndTime(resp.payload.data.endTime || "");
            setSelectedDays(resp.payload.data.recurringDays || []);
          }

          if (resp.payload.data.startDate && resp.payload.data.endDate) {
            setState([
              {
                startDate: new Date(resp.payload.data.startDate),
                endDate: new Date(resp.payload.data.endDate),
                key: "selection",
              },
            ]);
          }
          setLoading(false);
        } else {
          console.error("coupon data not found in response:", resp);
          setCoupon(null);
        }
        setLoading(false);
      });
    }, [couponId]);

    const discountValidation = () => {
      const discount = parseFloat(getValues("discount"));
      console.log("discount", discount);
      if (discount < 0 || discount > 100) {
        return "Discount must be between 0 and 100";
      }
    };

    const onSubmitdata = (data) => {
      console.log("data==", data);
      console.log("Cafe name", data.cafe);
      if (!data?.couponMode) {
        toast.error("Please select coupon mode");
        return;
      }
      if (data?.couponMode === "percentage" && !data.discount) {
        toast.error("Please enter discount percentage");
        return;
      }
      if (data?.couponMode === "freeItems") {
        if (data.minItems === undefined || data.minItems === null || data.minItems === "") {
          toast.error("Please enter min item count");
          return;
        } else if (data?.freeItems === undefined || data?.freeItems === null || data?.freeItems === "") {
          toast.error("Please enter free item count");
          return;
        }
      }

      // Time restriction validation
      if (timeRestricted) {
        if (!startTime || !endTime) {
          toast.error("Please enter start time and end time");
          return;
        }
        if (selectedDays.length === 0) {
          toast.error("Please select at least one day for recurring coupon");
          return;
        }
        // Validate time format
        const timeRegex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
        if (!timeRegex.test(startTime) || !timeRegex.test(endTime)) {
          toast.error("Invalid time format. Use HH:mm (24-hour)");
          return;
        }
        // Validate end time is after start time
        if (startTime >= endTime) {
          toast.error("End time must be after start time");
          return;
        }
      }

      // Validate dates are not in the past
      if (startDate) {
        const selectedStartDate = new Date(startDate);
        const now = new Date();
        
        if (timeRestricted && startTime) {
          // If time restricted, check date + time combination
          const [hours, minutes] = startTime.split(':');
          const startDateTime = new Date(selectedStartDate);
          startDateTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);
          
          if (startDateTime < now) {
            toast.error("Start date and time must be in the future");
            return;
          }
        } else {
          // If not time restricted, just check date
          const startOfDay = new Date(selectedStartDate);
          startOfDay.setHours(0, 0, 0, 0);
          const todayStart = new Date(now);
          todayStart.setHours(0, 0, 0, 0);
          
          if (startOfDay < todayStart) {
            toast.error("Start date cannot be in the past");
            return;
          }
        }
      }

      if (endDate) {
        const selectedEndDate = new Date(endDate);
        const selectedStartDate = new Date(startDate);
        
        if (selectedEndDate < selectedStartDate) {
          toast.error("End date must be after or equal to start date");
          return;
        }
      }

      if (data.name.trim().length === 0) {
        document.getElementById("name").focus();
      } else {
        setSubmitting(true);
        setError(null);
        const apiData = {
          name: data.name,
          couponCode: data.couponCode.toUpperCase(),
          couponMode: data.couponMode,
          startDate: startDate ? new Date(startDate).toISOString() : null,
          endDate: endDate ? new Date(endDate).toISOString() : null,
          oneTime: isOff,
          cafe: data.cafe ? data.cafe?.id || data.cafe : coupon?.cafe?._id,
        };

        // Add time-based fields
        if (timeRestricted) {
          apiData.timeRestricted = true;
          apiData.startTime = startTime;
          apiData.endTime = endTime;
          apiData.recurringDays = selectedDays;
        } else {
          // If time restriction is disabled, explicitly set to false
          apiData.timeRestricted = false;
        }

        if (data.couponMode === "percentage") {
          if (data.discount && data.discount !== "") {
            apiData.discount = parseFloat(data.discount);
          }
        } else if (data.couponMode === "freeItems") {
          apiData.freeItems = parseInt(data.freeItems);
          apiData.minItems = parseInt(data.minItems);
          apiData.multiple = isFreeOff;
          // Set ceilingAmount to 0 if empty (to clear old value), otherwise parse the number
          apiData.ceilingAmount = (data.ceilingAmount && data.ceilingAmount !== "") 
            ? parseFloat(data.ceilingAmount) 
            : 8; // Default value of 8 if empty as default value in db is set to 8
        }

        console.log("cpupon data", apiData);
        data.actionUrl = `coupons/${couponId}`;
        data.actionMethod = "patch";
        data.apiData = apiData;
        console.log("apiData: " + JSON.stringify(data.apiData));
        dispatch(Entry(data)).then((resp) => {
          setSubmitting(false);
          if (resp.payload.code === 200) {
            toast.success("coupon updated successfully");
            setIsEditMode(false);
            setIsUpdated(true);
            setTimeout(() => {
              handleClose();
            }, 2000);
          } else {
            setError(resp.payload.message);
            toast.error("Error updating coupon");
          }
        });
      }
    };

    console.log("start datee---", startDate, endDate);

    const getCafes = async () => {
      const cafes = await axios.get(REACT_APP_API_CAFES_DROPDOWN);
      setCafes(cafes.data?.data?.cafes?.selectdata);
    };

    const couponModes = [
      { label: "Percentage", value: "percentage" },
      { label: "Free Items", value: "freeItems" },
    ];

    const daysOfWeek = [
      { label: "Sunday", value: 0 },
      { label: "Monday", value: 1 },
      { label: "Tuesday", value: 2 },
      { label: "Wednesday", value: 3 },
      { label: "Thursday", value: 4 },
      { label: "Friday", value: 5 },
      { label: "Saturday", value: 6 },
    ];

    const mode = watch("couponMode");
    useEffect(() => {
      setCouponMode(mode);
    }, [mode]);
    return (
      <div className={styles.popupbox}>
        <div className={styles.box} id={styles.box}>
          {/* Flex container for close button, heading, and edit button */}
          <div className="d-flex align-items-center gap-3">
            <button
              className={styles.closeicon}
              aria-label="Close"
              onClick={handleClose}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
            {/* Conditionally render the heading based on isEditMode */}
            <h2 className={styles.heading}>
              {isEditMode ? "Edit Coupon Details" : "Coupon Details"}
            </h2>

            {/* Show edit button only when not in edit mode */}
            {!isEditMode && edit && (
              <button
                className={`${styles.formbtnedit}`} // Add your custom class for styling
                onClick={() => setIsEditMode(true)}
                aria-label=""
              >
                <FontAwesomeIcon icon={faEdit} /> {/* Edit icon */}
                Edit
              </button>
            )}
          </div>

          <div className="container-fluid mt-5">
            {open && (
              <div className="datepicker-wrapper position-relative">
                <button
                  className="btn-close custom-close"
                  onClick={() => setOpen(false)}
                  aria-label="Close"
                ></button>
                <div className="datepicker-container">
                  <DateRangePicker
                    onChange={handleOnChange}
                    showSelectionPreview
                    moveRangeOnFirstSelection={false}
                    months={2}
                    ranges={state}
                    minDate={isEditMode ? new Date() : undefined}
                    direction="horizontal"
                    dateDisplayFormat="yyyy-MM-dd"
                    staticRanges={[]}
                    inputRanges={[]}
                  />
                </div>
              </div>
            )}

            {loading ? (
              <div className="text-center mt-5">
                <Loader />
                <p>Loading coupon data...</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit(onSubmitdata)}>
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <TextInput
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      labelstyle={styles.formlabel}
                      label="Name"
                      fieldName="name"
                      placeHolder="Enter Coupon Name"
                      maximLength={30}
                      register={register}
                      errors={errors}
                      readOnly={!isEditMode}
                      isRequired
                      mandatory
                    />
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <TextInput
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      labelstyle={styles.formlabel}
                      label="Coupon Code"
                      fieldName="couponCode"
                      placeHolder="Enter Coupon Code"
                      register={register}
                      maximLength={20}
                      RegularExp={RegularExp}
                      errors={errors}
                      readOnly={!isEditMode}
                      isRequired
                      mandatory
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <SelectBox
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      name="couponMode"
                      label="Coupon Mode"
                      labelstyle={styles.formlabel}
                      control={control}
                      register={register}
                      values={couponModes}
                      readOnly={!isEditMode}
                      Disabled={!isEditMode}
                      errors={errors}
                      // placeholder={coupon?.cafe?.name}
                      mandatory
                      isRequired
                    />
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <label className={styles.formlabel}>Single Use</label>
                    <div className="col">
                      <label className={togglestyles.switch}>
                        <input
                          type="checkbox"
                          checked={isOff}
                          onClick={handleButtonClick}
                          disabled={!isEditMode}
                        />
                        <span className={togglestyles.slider} />
                      </label>
                    </div>
                  </div>
                  {/* <div className="col-lg-6 col-md-12 col-sm-12">
                  <NumberInput
                    className={styles.inputbox}
                    classNamedark={styles.inputbox1}
                    labelstyle={styles.formlabel}
                    label="Discount Limit"
                    placeHolder="Enter Limit"
                    fieldName="limit"
                    register={register}
                    errors={errors}
                    readOnly={!isEditMode}
                    // isRequired
                    // mandatory
                  />
                </div> */}
                </div>
                <div className="row">
                  {couponMode === "percentage" && (
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <NumberInput
                        className={styles.inputbox}
                        classNamedark={styles.inputbox1}
                        labelstyle={styles.formlabel}
                        label="Discount(%)"
                        placeHolder="Enter Discount"
                        fieldName="discount"
                        validation={discountValidation}
                        register={register}
                        errors={errors}
                        readOnly={!isEditMode}
                        // isRequired
                        // mandatory
                      />
                    </div>
                  )}
                  {couponMode === "freeItems" && (
                    <>
                      <div className="col-lg-2 col-md-3 col-sm-3">
                        <NumberInput
                          className={styles.inputbox}
                          classNamedark={styles.inputbox1}
                          labelstyle={styles.formlabel}
                          label="Minimum Item"
                          placeHolder="Enter Min Items"
                          fieldName="minItems"
                          validation={discountValidation}
                          register={register}
                          errors={errors}
                          readOnly={!isEditMode}
                          isRequired
                          mandatory
                        />
                      </div>
                      <div className="col-lg-2 col-md-3 col-sm-3">
                        <NumberInput
                          className={styles.inputbox}
                          classNamedark={styles.inputbox1}
                          labelstyle={styles.formlabel}
                          label="Free Item"
                          placeHolder="Enter Free Items"
                          fieldName="freeItems"
                          validation={discountValidation}
                          register={register}
                          errors={errors}
                          readOnly={!isEditMode}
                          isRequired
                          mandatory
                        />
                      </div>
                      <div className="col-lg-2 col-md-3 col-sm-3">
                        <label className={styles.formlabel}>Multiple</label>
                        <div className="col">
                          <label className={togglestyles.switch}>
                            <input
                              type="checkbox"
                              checked={isFreeOff}
                              onClick={() => setIsFreeOff(!isFreeOff)}
                              disabled={!isEditMode}
                            />
                            <span className={togglestyles.slider} />
                          </label>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <SelectBox
                      className={styles.inputbox}
                      classNamedark={styles.inputbox1}
                      name="cafe"
                      label="Cafe"
                      labelstyle={styles.formlabel}
                      control={control}
                      register={register}
                      values={cafes}
                      errors={errors}
                      placeholder={coupon?.cafe?.name}
                      // mandatory
                      // isRequired
                      Disabled={!isEditMode}
                      readOnly={!isEditMode}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <label className={styles.formlabel}>
                      Enable Time Restrictions
                    </label>
                    <div className="col">
                      <label className={togglestyles.switch}>
                        <input
                          type="checkbox"
                          checked={timeRestricted}
                          onChange={() => setTimeRestricted(!timeRestricted)}
                          disabled={!isEditMode}
                        />
                        <span className={togglestyles.slider} />
                      </label>
                    </div>
                    <small style={{ color: "#999", fontSize: "12px" }}>
                      Enable to set specific hours and days (e.g., "Early Bird Special")
                    </small>
                  </div>
                </div>

                {timeRestricted && (
                  <>
                    <div className="row mt-3">
                      <div className="col-lg-3 col-md-6 col-sm-6">
                        <label className={styles.formlabel}>
                          Start Time <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="time"
                          className={styles.inputbox}
                          value={startTime}
                          onChange={(e) => setStartTime(e.target.value)}
                          disabled={!isEditMode}
                          readOnly={!isEditMode}
                          required={timeRestricted}
                        />
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-6">
                        <label className={styles.formlabel}>
                          End Time <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="time"
                          className={styles.inputbox}
                          value={endTime}
                          onChange={(e) => setEndTime(e.target.value)}
                          disabled={!isEditMode}
                          readOnly={!isEditMode}
                          required={timeRestricted}
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-12">
                        <label className={styles.formlabel}>
                          Active Days <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {daysOfWeek.map((day) => (
                            <button
                              key={day.value}
                              type="button"
                              onClick={() => handleDayToggle(day.value)}
                              disabled={!isEditMode}
                              className={`btn btn-sm ${
                                selectedDays.includes(day.value)
                                  ? "btn-primary"
                                  : "btn-outline-secondary"
                              }`}
                              style={{
                                minWidth: "80px",
                                padding: "8px 12px",
                                borderRadius: "4px",
                              }}
                            >
                              {day.label}
                            </button>
                          ))}
                        </div>
                        <small
                          style={{
                            color: "#999",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          Select days when this time-restricted coupon will be active
                        </small>
                      </div>
                    </div>
                  </>
                )}

                <div className="row mt-3">
                  {/* <div className="col-lg-6 col-md-6 col-sm-6">
                  <label
                    htmlFor="coupondescription"
                    className={styles.formlabel}
                  >
                    Description
                    <span style={{color:"red", marginLeft: '3px'}}>*</span>
                  </label>
                  <textarea
                    id="coupondescription"
                    className={`${styles.inputbox}`}
                    placeholder="Enter Description"
                    {...register("description", {
                      required: "Description is required.",
                    })}
                    rows={1}
                    readOnly={!isEditMode}
                    disabled={!isEditMode}
                    style={{ resize: "none", overflowY: "auto" }}
                    onInput={(e) => {
                      e.target.style.height = "auto";
                      e.target.style.height = `${Math.min(
                        e.target.scrollHeight,
                        200
                      )}px`;
                    }}
                  />
                {errors.description?.message && (
                  <span className={styles.errormsg}>{errors.description.message}</span>
                )}
                </div> */}
                  {couponMode === "freeItems" && (
                    <div className="col-lg-2 col-md-3 col-sm-3">
                      <NumberInput
                        className={styles.inputbox}
                        classNamedark={styles.inputbox1}
                        labelstyle={styles.formlabel}
                        label="Ceiling Amount"
                        placeHolder="Enter Ceiling Amount"
                        fieldName="ceilingAmount"
                        validation={discountValidation}
                        register={register}
                        errors={errors}
                        readOnly={!isEditMode}
                        // isRequired
                        // mandatory
                      />
                    </div>
                  )}
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <DateRangeFilter
                      onChange={handleDateRangeChange}
                      open={open}
                      setOpen={setOpen}
                      register={register}
                      setValue={setValue}
                      disabled={!isEditMode}
                      startDateProp={startDate}
                      endDateProp={endDate}
                    />
                  </div>
                </div>
                {isEditMode && (
                  <div className="d-flex justify-content-center mt-3">
                    <input
                      className={styles.formbtn}
                      type="submit"
                      disabled={submitting}
                      value={submitting ? "Please wait.." : "Submit"}
                    />
                    {/* <input
                      className={styles.resetbtn}
                      type="button"
                      value="Reset"
                      onClick={() => {
                        reset();
                      }}
                    /> */}
                  </div>
                )}
                <br />
                {error && (
                  <h6
                    className={styles[errormsgStyle]}
                    style={{ float: "right" }}
                  >
                    {error}
                  </h6>
                )}
              </form>
            )}
          </div>
        </div>
      </div>
    );
  }
);

export default EditCouponPopUp;
